var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedinBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 31,
    viewBox: "0 0 24 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 6.54736C16.5304 6.54736 17.0391 6.75808 17.4142 7.13315C17.7893 7.50822 18 8.01693 18 8.54736V22.5474C18 23.0778 17.7893 23.5865 17.4142 23.9616C17.0391 24.3366 16.5304 24.5474 16 24.5474H2C1.46957 24.5474 0.960859 24.3366 0.585786 23.9616C0.210714 23.5865 0 23.0778 0 22.5474V8.54736C0 8.01693 0.210714 7.50822 0.585786 7.13315C0.960859 6.75808 1.46957 6.54736 2 6.54736H16ZM15.5 22.0474V16.7474C15.5 15.8828 15.1565 15.0536 14.5452 14.4422C13.9338 13.8308 13.1046 13.4874 12.24 13.4874C11.39 13.4874 10.4 14.0074 9.92 14.7874V13.6774H7.13V22.0474H9.92V17.1174C9.92 16.3474 10.54 15.7174 11.31 15.7174C11.6813 15.7174 12.0374 15.8649 12.2999 16.1274C12.5625 16.39 12.71 16.7461 12.71 17.1174V22.0474H15.5ZM3.88 12.1074C4.32556 12.1074 4.75288 11.9304 5.06794 11.6153C5.383 11.3002 5.56 10.8729 5.56 10.4274C5.56 9.49736 4.81 8.73736 3.88 8.73736C3.43178 8.73736 3.00193 8.91542 2.68499 9.23235C2.36805 9.54929 2.19 9.97915 2.19 10.4274C2.19 11.3574 2.95 12.1074 3.88 12.1074ZM5.27 22.0474V13.6774H2.5V22.0474H5.27Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinBox);
export default __webpack_public_path__ + "static/media/linkedin-box.269f3b5c578bf309e386c3aad4df0d0d.svg";
export { ForwardRef as ReactComponent };